export default __webpack_public_path__ + "static/media/fevr-utility.1f9ed6c3.svg";